// Minimale Markdown→HTML voor onze seed-tekst. Ondersteunt:
// - paragrafen (lege regels)
// - **vet** en *cursief*
// - inline `code`
// - links [tekst](url)
// - ongeordende lijsten (regels die met '- ' beginnen)
// Geen tabellen, geen geneste lijsten, geen blokquotes. Houd het simpel.

function esc(s) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function inline(s) {
  // Werk op een ge-escaped string, dan markdown-syntax → HTML
  let out = esc(s)
  // Inline code eerst (zodat **/* binnen code niet getriggerd worden)
  out = out.replace(/`([^`]+)`/g, (_, code) => `<code>${code}</code>`)
  // Links [tekst](url)
  out = out.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, txt, url) => {
    const u = url.replace(/"/g, '%22')
    return `<a href="${u}" target="_blank" rel="noopener">${txt}</a>`
  })
  // **vet**
  out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  // *cursief* (na vet om dubbele * niet als enkele te pakken)
  out = out.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>')
  return out
}

export function md(src) {
  if (!src) return ''
  const text = String(src).replace(/\r\n/g, '\n').trim()
  const blocks = text.split(/\n{2,}/)
  const html = blocks.map(block => {
    const lines = block.split('\n')
    const isList = lines.every(l => /^\s*-\s+/.test(l) || l.trim() === '')
    if (isList) {
      const items = lines
        .filter(l => /^\s*-\s+/.test(l))
        .map(l => `<li>${inline(l.replace(/^\s*-\s+/, ''))}</li>`)
        .join('')
      return `<ul>${items}</ul>`
    }
    return `<p>${inline(block).replace(/\n/g, '<br>')}</p>`
  }).join('')
  return html
}
